import SampleToolsModule from './module';

export default SampleToolsModule;
